module.exports = __webpack_public_path__ + "static/media/cctv_bg.ad113d8a.png";